import { yupResolver } from '@hookform/resolvers/yup';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import _ from '@lodash';
import { startLoading, stopLoading } from 'app/store/utilSlice';
import { selectCurrentFolder, uploadFileItem } from 'app/store/fileItemsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { dispatchResultMessage } from '../utils';
import ControlledTextField from '../form/ControlledTextField';
import DefaultButton from '../layout/DefaultButton';
import ControlledCheckbox from 'app/shared-components/form/ControlledCheckbox';
import { errorMessage } from 'app/shared-components/util/message';
import fileTypes from './fileTypes.json';



/**
 * Form Validation Schema
 * 
 */
const schema = yup.object().shape({
  name: yup.string().required('You must enter a file name'),
  description: yup.string(),
  knowledgeBase: yup.boolean(),
});

const validKBExtensions = ["TXT", "CSV", "PDF", "DOC", "DOCX", "XLS", "XLSX", "HTML", "MD"];
const MB= 1048576;
const maxFileSize= 100 * MB;
const maxKBFileSize= 50 * MB;
const maxFileSizeText= "100 MB";
const maxKBFileSizeText= "50 MB";

function validateFile(file, isKb) 
{
	const out= {};
  const fileType= file?.type;
  const found = fileTypes.find((element) => element.type == fileType);
	const isValidKBType= found ? validKBExtensions.some(ext => found.label == ext) : false;
  out.validType= isKb ? isValidKBType : Boolean(found); 
  out.size= file?.size ? file.size : (maxFileSize + 1);
  out.type= fileType;
  out.maxSize= isKb ? maxKBFileSize : maxFileSize;
  out.maxSizeText= isKb ? maxKBFileSizeText : maxFileSizeText;
  out.validSize= out.size < out.maxSize;
  out.isValid= out.validType && out.validSize;
  out.message= !out.validType ? "File type is not allowed" + (isKb ? " in Knowledge Base" : "") + ": " + fileType :
               !out.validSize ? "Maximum file size" + (isKb ? " for Knowledge Base" : "") + " is " + out.maxSizeText :
               "";
  return out;
}

  
function UploadFileDialog(props) {
  const { file, onCloseDialog } = props;
  const dispatch = useDispatch(); 
  const open= Boolean(file);
  const folderId= useSelector(selectCurrentFolder); 
  console.log(file);
  
  const defaultValues = {
	  name: '',
	  description: '',
	  knowledgeBase: false,
  };
	
  const values = {
	  name: open ? file.name : '',
	  description: '',
	  knowledgeBase: false,
  };
  
  const { handleSubmit, formState, control, reset } = useForm({
    mode: 'onChange',
    defaultValues: defaultValues,
    values: values,
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;

  function handleCloseDialog() {
    onCloseDialog();
  }

  function handleDiscard() {
    onCloseDialog();
  }

  
  function onSubmit(data){
	  if (!file) return;
	  
	  const validation= validateFile(file, data.knowledgeBase);
	  if (!validation.isValid){
	     errorMessage(dispatch, validation.message);
	     return;
	  }
	  
	  //set the loading flag and close the dialog
	  dispatch(startLoading());
    onCloseDialog();
	  
	  //Upload file and update user data
	  dispatch(uploadFileItem({file: file, 
		                       folderId: folderId,
		                       name: data.name, 
		                       knowledgeBase: data.knowledgeBase,
		                       description: data.description})).then((resp) => {
		    dispatchResultMessage(dispatch, resp, "Upload Successful!")
    });
  }


  return (
      
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
        scroll="body"
      >
        <AppBar position="static" color="secondary" elevation={0}>
          <Toolbar className="flex w-full">
            <Typography variant="subtitle1" color="inherit">
              Upload File
            </Typography>
          </Toolbar>
        </AppBar>

        <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-32 sm:pb-0' }}>
            <ControlledTextField name="name" label="File name"
                             control={control} errors={errors}
             				 autoFocus required fullWidth />
        
            <ControlledTextField name="description" label="File description"
                             control={control} errors={errors}
             				 required fullWidth />
             				 
            <ControlledCheckbox name="knowledgeBase" control={control} errors={errors}
			                       label={"Include in AI Knowledge Base?"}/>  
          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">

            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
              <DefaultButton text="Cancel" onClick={handleDiscard} />
              <DefaultButton text="Upload"
	              disabled={_.isEmpty(dirtyFields) || !isValid}
	              submit />
            </div>
          </DialogActions>
        </form>
      </Dialog>
  );
}

export default UploadFileDialog;
